export default __webpack_public_path__ + "static/media/profile-icon-red.318b147c.svg";